import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../shared/api.service';
import { PollItemData } from '../../../models/PollItemData';
import { PollDashboardResponse } from '../../../models/PollDashBoardResponse';
import { AuthenticationService } from '../../../shared/authentication.service';
import { LicenseService } from '../../../shared/licens.service';
import { SubsciptionData, LicenseData } from '../../../models/LicenseData';
import { Common } from '../../../shared/common';
import { TermLength } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-length',
  templateUrl: 'pap-length.component.html',
  styleUrls: ['./pap-length.component.less', '../../../shared/common.less'],
})

export class PapLengthComponent implements OnInit {
  @Input() termLength: TermLength;
  @Output() termLengthChange = new EventEmitter<TermLength>();

  needPap: boolean = undefined;

  constructor(
    private router: Router,
  ) {}
  
  validateYears() {

    if (this.termLength.duration[0] < 0) {
      this.termLength.duration[0] = 0;
    } else if (this.termLength.duration[0] > 4) {
      this.termLength.duration[0] = 4;
    }
    
    if (this.termLength.duration[0] == 4) {
      this.termLength.duration[1] = 0;
    }
    
    this.onLengthChange();
  }

  validateMonths() {
    if  (this.termLength.duration[0] == 4) {
      setTimeout(() => {
        this.termLength.duration[1] = 0;
        this.onLengthChange();
      });
      return;
    } else if (this.termLength.duration[1] < 0) {
      this.termLength.duration[1] = 0;
    } else if (this.termLength.duration[1] > 11) {
      this.termLength.duration[1] = 11;
    }
    
    this.onLengthChange();
  }

  onLengthChange() {
    this.termLengthChange.emit(this.termLength);
  }

  goToPollCreation() {
    this.router.navigate(['/poll-creation']);
  }

  ngOnChanges(): void {
    
  }
  
  ngOnInit(): void {
  }
}
